// import { Maybe, Parameters, ReturnType } from './declarations';

/**
 * Does nothing
 */
function noOp() {}

/**
 * Get union of two sets.
 * @param setA
 * @param setB
 * @returns union of two sets
 */
function union(setA, setB) {
  return new Set([...setA, ...setB]);
}

/**
 * Get intersection of two sets.
 * @param setA
 * @param setB
 * @returns intersection of two sets
 */
function intersection(setA, setB) {
  return new Set([...setA].filter(x => setB.has(x)));
}

/**
 * Get difference of two sets.
 * @param setA
 * @param setB
 * @returns difference between two sets
 */
function difference(setA, setB) {
  return new Set([...setA].filter(x => !setB.has(x)));
}

/**
 * Identifies if value is NaN.
 * @param val
 */
function isNaN(val) {
  if (typeof val === 'number') {
    return Number.isNaN(val);
  }
  return false;
}

/**
 * Identifies if value is not defined.
 * undefined, null and NaN are not considered as defined.
 * @param val
 */
function isNotDefined(val) {
  return val === undefined || val === null || isNaN(val);
}

/**
 * Identifies if value is defined.
 * @param val
 */
function isDefined(val) {
  return !isNotDefined(val);
}

/**
 * Identifies if value is falsy.
 * undefined, null, NaN and false are considered as false value.
 * @param val
 * @param override list of additional values that are considered false values
 */
function isFalsy(val) {
  let override = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return isNotDefined(val) || val === false || override.includes(val);
}

/**
 * Identifies if value is truthy.
 * @param val
 * @param override list of additional values that are considered true values
 */
function isTruthy(val) {
  let override = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return !isFalsy(val) || override.includes(val);
}

/**
 * Identifies if value is falsy string.
 * undefined, null, NaN, false, '' are considered as false value.
 * @param val
 */
function isFalsyString(val) {
  return isFalsy(val, ['']);
}

/**
 * Identifies if value is truthy string.
 * @param val
 */
function isTruthyString(val) {
  return !isFalsyString(val);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isFn(value) {
  return typeof value === 'function';
}

/**
 * Resolves if first argument is function with other arguments as argument to
 * user supplied function.
 * @param variable either a function to resolive or any value
 * @param args arguments for user supplied function
 * @returns value resolved from user supplied function
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, max-len
// eslint-disable-next-line @typescript-eslint/no-explicit-any, max-len
function resolve(variable) {
  if (isFn(variable)) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    const value = variable(...args);
    return value;
  }
  return variable;
}

export { difference, intersection, isDefined, isFalsy, isFalsyString, isNaN, isNotDefined, isTruthy, isTruthyString, noOp, resolve, union };
//# sourceMappingURL=core.js.map
